module.exports = __webpack_public_path__ + "img/组27.520f568c.png";